/**   
 * api接口统一管理
 */
import { get, post } from './setting'

const user_api = {
    userinfo : '/api/user/info',
    queryplayer : '/api/user/getNickName',
    bind : '/api/user/bind',
    share : '/api/team/invite',//邀请
    apply_list : '/api/tyjy/applylist',//申请列表
    invite_apply : '/api/tyjy/apply',
    invite_info : '/api/share/getNickName',
    apply_agree : '/api/team/review',//审核同意
    team_info : '/api/team/info',//小队信息
    join_apply : '/api/team/apply',//加入小队申请
    team_create : '/api/team/create',//创建小队
    score_info : '/api/user/score',//积分信息
    pay_info : '/api/other/costBack',//消费返还信息
    task_info : '/api/user/task/dict',//任务信息 t01：累计神兵值，t02：累计活跃度，t03：结义组队，t04：队员匹配，t05：小队签到，t06：个人签到
    task_apply : '/api/user/task/receive',//任务领奖
    weapon_info : '/api/other/weapon',//专属武器信息
    weapon_apply : '/api/other/weapon/claim',//专属武器领取
    pack_apply : '/api/tyjy/optional/claim',//自选领取
    shop_list : '/api/gift/shop',//商城列表
    shop_status : '/api/tyjy/optional',//自选状态
    back_list : '/api/other/costBack',//消费返还
    team_task_apply : '/api/Tyjy/TeamGift',//结义小队一键领取
    box_list : '/api/gift/userGiftList?pageIndex=1&pageSize=100&source=0',//自选箱记录
}

export const apiUserInfo = p => get(user_api.userinfo, p);
export const apiUserQuery = p => get(user_api.queryplayer, p);
export const apiUserBind = p => post(user_api.bind, p);
export const apiScoreInfo = p => get(user_api.score_info, p);
export const apiTaskInfo = p => get(user_api.task_info, p);
export const apiTaskApply = p => post(user_api.task_apply, p);
export const apiBoxList = p => get(user_api.shop_list, p);
export const apiPackApply = p => post(user_api.pack_apply, p);
export const apiTeamInfo = p => get(user_api.team_info, p);
export const apiTeamCreate = p => get(user_api.team_create, p);
export const apiTeamJoin = p => get(user_api.join_apply, p);
export const apiShare = p => get(user_api.share, p);
export const apiInviteApply = p => post(user_api.invite_apply, p);
export const apiInviteInfo = p => get(user_api.invite_info, p);
export const apiApplyAgree = p => post(user_api.apply_agree, p);
export const apiTeamtaskApply = p => post(user_api.team_task_apply, p);
export const apiBackInfo = p => get(user_api.back_list, p);
export const apiSignInfo = p => get(user_api.team_info, p);
export const apiApplyInfo = p => get(user_api.team_info, p);
export const apiBoxInfo = p => get(user_api.shop_status, p);
export const apiWeaponInfo = p => get(user_api.weapon_info, p);
export const apiWeaponApply= p => post(user_api.weapon_apply, p);
export const apiPayInfo = p => get(user_api.pay_info, p);